import { render, staticRenderFns } from "./CompanyQuestionnaireReview.vue?vue&type=template&id=008b4289&"
import script from "./CompanyQuestionnaireReview.vue?vue&type=script&lang=js&"
export * from "./CompanyQuestionnaireReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports